<template>
  <!-- 聊天框 -->
  <a-alert v-if="isShowAlert" banner closable style="margin: 5px 10px">
    <!-- 如果是个人身份 -->
    <template #message>
      <div>
        {{ $t('升级权益,未读询盘强提醒，让你牢牢把握商机') }}
        <a-button type="link" @click="toUpgrade()">
          {{ $t('去了解') }}
        </a-button>
      </div>
    </template>
  </a-alert>
</template>

<script>
export default {
  name: 'PersonAlert',
  computed: {
    isShowAlert() {
      return (
        !this.$store.state.userInfo.memberSetMealInfo ||
        !this.$store.state.userInfo.memberSetMealInfo.setMealCode ||
        this.$store.state.userInfo.memberSetMealInfo.setMealCode === 10000 ||
        this.$store.state.userInfo.memberSetMealInfo.setMealCode === 110000
      )
    },
  },
  methods: {
    // 前往升级页面
    toUpgrade() {
      this.$store.commit('chat/switchChatModelShow', false)
      this.$router.push('/upgradevip')
    },
  },
}
</script>
